import { Injectable } from '@angular/core';
import { RequestService } from '../requestService/request.service';

@Injectable({
  providedIn: 'root'
})
export class BookmarkService {

  constructor(private requestService: RequestService) { }

  /** Add Bookmark for an asset.
  * @param asset Asset object
  * @param seek Time in seconds
  * @param percentage Bookmark percentage in %
  */
  addBookmark(params) {
    let req = {
      url: "/api/personalizedContent/addBookmark",
      req: {
        assetId: params.asset.currentEpisode ? params.asset.currentEpisode.id : params.asset.id,
        seriesId: params.asset.type == 1 ? params.asset.id : 0,
        seek: params.seek,
        percentage: params.percentage,
        assetTitle: params.asset.currentEpisode ? params.asset.currentEpisode.title : params.asset.title
      }
    };

    if (params.asset.type == 1) {
      req.req["episodeNumber"] = params.asset.currentEpisode.episodeNumber;
      req.req["seasonNumber"] = params.asset.currentEpisode.seasonNumber;
    }

    return this.requestService.mainPostRequest(req);
  }

  /** Remove a list of Bookmarks.
  * @param assetIds Array of ids
  */
  removeBookmark(assetIds) {
    let req = {
      url: "/api/personalizedContent/deleteBookmarks",
      req: {
        assetsIds: assetIds
      }
    };
    return this.requestService.mainPostRequest(req);
  }

  /** Get Bookmarks list.
  * @param count Count *Optional - Default 20
  * @param offest Offest *Optional - Default 0
  */
  getBookmarks(params) {
    let req = {
      url: "/api/personalizedContent/getMyBookmarks",
      req: {
        count: params.count ? params.count : 20,
        offset: params.offset ? params.offset : 0
      }
    };
    return this.requestService.mainPostRequest(req);
  }
}